"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const setupDiscovery_1 = __importDefault(require("./setupDiscovery"));
const actionNames = __importStar(require("../constants/actions"));
const setup = (utils) => () => __awaiter(void 0, void 0, void 0, function* () {
    const { auth, next, state } = utils;
    yield setupDiscovery_1.default(utils)({
        type: actionNames.API_SETUP_DISCOVERY,
        payload: undefined,
        meta: undefined,
    });
    const getPayload = () => {
        var _a, _b, _c;
        return ({
            isLoggedIn: auth.isLoggedIn,
            isLocked: (_a = auth.isLocked) !== null && _a !== void 0 ? _a : false,
            canPersist: (_b = auth.canPersist) !== null && _b !== void 0 ? _b : false,
            isPersisted: (_c = auth.isPersisted) !== null && _c !== void 0 ? _c : false,
            supportedPersistenceMechanism: auth.supportedPersistenceMechanism,
        });
    };
    const updateState = () => {
        next({
            type: actionNames.API_AUTH_STATE_CHANGE,
            payload: getPayload(),
        });
    };
    yield auth.setup();
    if (!(state === null || state === void 0 ? void 0 : state.subscribed)) {
        auth.subscribe(updateState);
        state.subscribed = true;
        updateState();
    }
    next({
        type: actionNames.API_SETUP,
        payload: getPayload(),
    });
});
exports.default = setup;
